import React from "react";
import { useTranslate } from "react-admin";

const CalendarTitle = ({ record }) => {
    const translate = useTranslate();

    return (
        <span>
            {
                ! record ?    translate("calendar.message.list") :
                ! record.id ? translate("calendar.message.new") :
                              translate("calendar.message.instance", { ...record })
            }
        </span>
    );
}

export default CalendarTitle;
